import { Component, OnInit, HostBinding, Input, EventEmitter, Output, ViewEncapsulation, ViewChild, ElementRef, HostListener } from '@angular/core';
import { LabelStyleDialogService } from '../label-style-dialog.service.';
import { LabelStyle } from 'src/app/types/LabelStyle';
import { ButtonComponent } from 'src/app/components/button/button.component';

@Component({
  selector: 'app-label-style-button',
  templateUrl: './label-style-button.component.html',
  styleUrls: ['./label-style-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabelStyleButtonComponent implements OnInit {

  @ViewChild('button', { static: true }) button!: ButtonComponent;

  @Input() title = 'Label Style';
  @Input() viewOnly = 'false';
  @Input() style: LabelStyle = '';
  @Input() revertStyle?: LabelStyle = undefined;
  @Input() disabled = false;
  @Output() styleChange = new EventEmitter<LabelStyle>();
  @HostListener('sl-focus', ['$event'])
  onSLFocus(event: any) {
    this.setFocus();
  }
  @HostListener('focus', ['$event'])
  onFocusEvent(event: any) {
    this.setFocus()
  }

  get value(): LabelStyle {
    return this.style;
  }
  set value(style: LabelStyle) {
    this.style = style;
  }
  constructor(private labelSvc: LabelStyleDialogService) { }

  ngOnInit() {

  }

  /**
   * Sets focus to the button element
   */
  public setFocus(): void {
    this.button.Focus();
  }

  Show() {
    if (this.disabled === true) return;
    const handler = (data: LabelStyle | any) => {
      this.style = data as LabelStyle;
      this.styleChange.emit(this.style);

    };

    this.labelSvc.Show(handler, this.style, this.viewOnly !== 'false', this.revertStyle);

  }

}
